/**
 * lib-blueprint
 *
 * Adapptio library for processing blueprints.
 *
 * @package lib-blueprint
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ISchemaConstDateOpts, SchemaConstDate, ISchemaConstDate } from "../const/SchemaConstDate";
import { ISchemaValue, ISchemaValueOpts, SchemaValue } from "./SchemaValue";

export interface ISchemaValueDateOpts extends ISchemaValueOpts<ISchemaConstDate>, ISchemaConstDateOpts {}

/**
 * Schema: Date value
 *
 * @param opts Schema options
 */
export function SchemaValueDate(opts: ISchemaValueDateOpts): ISchemaValue<ISchemaConstDate> {

	return SchemaValue(SchemaConstDate(opts), opts);

}